import React from "react";

import { useScope } from "~/tools/impulse";

import { LinkFrom } from "../../../../components/react/link";
import { queryFullComponent } from "../../../../queries";
import { useQuery } from "../../../../queries/react-query";
import { COMPONENT_PATH, VIEW_MODE_TOPOLOGY } from "../../../../routes/Routes";

import type { RelatedResourcesDrawerState } from "./state";

export type TopologyLinkProps = Omit<RelatedResourcesDrawerState, "timeRange">;

export const TopologyLink: React.FC<TopologyLinkProps> = ({ timestamp, componentIdOrIdentifier, activeTabTitle }) => {
	const scope = useScope();
	const { error, data: fullComponent } = useQuery({
		refetchOnMount: false,
		refetchOnReconnect: false,
		refetchOnWindowFocus: false,

		...queryFullComponent({ componentIdOrIdentifier, timestamp }),
	});

	if (error != null) {
		return null;
	}

	if (fullComponent == null) {
		return <span className="skeleton button uppercase">View topology</span>;
	}

	const title = activeTabTitle.getValue(scope);
	const activeResource =
		fullComponent.relatedResources.find((resource) => resource.title === title) ?? fullComponent.relatedResources.at(0);

	if (activeResource == null) {
		return null;
	}

	return (
		<LinkFrom
			className="button button-primary uppercase"
			from={COMPONENT_PATH}
			params={(params) => ({ ...params, mode: VIEW_MODE_TOPOLOGY })}
			search={(search) => ({
				...search,
				explore: {
					type: "QUERY",
					// include the component in the result
					query: `(${activeResource.stql}) OR id = "${fullComponent.data.id}"`,
				},
				view: {
					showIndirectRelations: false,
					connectedComponents: true,
					neighboringComponents: false,
					showFullComponent: true,
				},
			})}
			theme="unstyled"
		>
			View topology
		</LinkFrom>
	);
};
